import LeftArrows from "../../assets/svg/LeftArrows.svg";
import RightArrows from "../../assets/svg/RightArrows.svg";
import Petrol_Vehicle_one from "../../assets/images/New1000EFIPetrol/1000EFI_new_doors_1_HD.jpg";
import Petrol_Vehicle_two from "../../assets/images/New1000EFIPetrol/1000EFI_new_doors_3_HD.jpg";
import Petrol_Vehicle_three from "../../assets/images/New1000EFIPetrol/1000EFI_with_New_doors_1_HD.jpg";
import Petrol_Vehicle_Four from "../../assets/images/New1000EFIPetrol/1000EFI_with_new_doors_2_HD.jpg";

import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { RouterPaths } from "../../router/router";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const GasolineSlider = ({ compact = false }) => {
  const navigate = useNavigate();
  const sliderRef = useRef(null);

  const images = [
    Petrol_Vehicle_one,
    Petrol_Vehicle_two,
    Petrol_Vehicle_three,
    Petrol_Vehicle_Four,
  ];

  const next = () => {
    sliderRef.current.slickNext();
  };

  const previous = () => {
    sliderRef.current.slickPrev();
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    cssEase: "ease-in-out",
    autoplay: true,
    autoplaySpeed: 5000,
  };

  if (compact) {
    return (
      <div className="flex flex-col flex-1 mt-0 overflow-hidden">
        {/* Slider with arrows */}
        <div className="group relative w-full aspect-[4/3] flex items-center justify-center border border-[#292929]">
          <div className="absolute left-0 z-10 flex items-center h-full pl-1 opacity-0 -translate-x-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0">
            <img
              src={LeftArrows}
              alt="Previous"
              className="w-[28px] md:w-[35px] lg:w-[30px] xl:w-[38px] cursor-pointer"
              onClick={previous}
            />
          </div>

          <div className="w-full px-[38px] md:px-[48px] lg:px-[40px] xl:px-[50px]">
            <Slider ref={sliderRef} {...settings}>
              {images.map((img, idx) => (
                <div
                  key={idx}
                  className="w-full flex items-center justify-center"
                >
                  <div className="flex items-center justify-center w-full aspect-[4/3]">
                    <img
                      src={img}
                      alt={`Model View ${idx}`}
                      className="max-w-full max-h-full object-contain scale-[1.3] transform"
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          <div className="absolute right-0 z-10 flex items-center h-full pr-1 opacity-0 translate-x-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0">
            <img
              src={RightArrows}
              alt="Next"
              className="w-[28px] md:w-[35px] lg:w-[30px] xl:w-[38px] cursor-pointer"
              onClick={next}
            />
          </div>
        </div>

        {/* Text and button */}
        <div className="flex flex-col flex-1 mt-3 px-1">
          <div className="font-[Roboto] font-extrabold 2xl:text-[22px] xl:text-[18px] lg:text-[15px] md:text-[16px] text-[15px] mb-2">
            TU-1000EFI-2
          </div>
          <div className="flex-1">
            <div className="font-[Roboto] font-normal 2xl:text-[18px] xl:text-[15px] lg:text-[13px] md:text-[14px] text-[13px] mb-2">
              A powerful 3-seat gas UTV built for demanding work and rugged
              environments. The TU-1000EFI-2 features a high-performance 1000cc
              EFI combustion engine, delivering strong torque, reliability, and
              consistent power across tough terrain.
            </div>
            <div className="font-[Roboto] font-normal 2xl:text-[18px] xl:text-[15px] lg:text-[13px] md:text-[14px] text-[13px]">
              Designed for all-day productivity, it includes a built-in heater
              for comfort in cold conditions, durable steel construction, and
              the capability to handle heavy loads, towing, and off-road tasks
              with ease. Ideal for agriculture, construction, and commercial
              applications where performance matters.
            </div>
          </div>
          <button
            onClick={() => {
              window.scrollTo(0, 200);
              navigate(RouterPaths.EFI);
            }}
            className="text-[#5B792E] font-[Roboto] border-[2px] lg:border-[3px] border-[#5B792E] font-bold px-[20px] lg:px-[18px] xl:px-[24px] py-[10px] 2xl:text-[20px] xl:text-[16px] lg:text-[13px] md:text-[14px] text-[13px] w-full mt-4"
          >
            EXPLORE TU-1000EFI-2
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="lg:mx-[40px] sm:mx-[20px] mx-[0px] mt-0 overflow-hidden">
      <div className="relative w-full aspect-[22/7] flex items-center justify-center">
        {/* Left Arrow */}
        <div className="absolute left-[45px] sm:left-[105px] lg:left-[155px] z-10 flex items-center justify-start h-full">
          <img
            src={LeftArrows}
            alt="Previous"
            className="lg:w-[90px] md:w-[70px] w-[40px] cursor-pointer"
            onClick={previous}
          />
        </div>

        {/* Image Container */}
        <div className="w-full px-[50px] sm:px-[110px] lg:px-[170px]">
          <Slider ref={sliderRef} {...settings}>
            {images.map((img, idx) => (
              <div
                key={idx}
                className="w-full h-full flex items-center justify-center"
              >
                <div className="flex items-center justify-center w-full h-full aspect-[22/7] pb-0">
                  <img
                    src={img}
                    alt={`Model View ${idx}`}
                    className="max-w-full max-h-full object-contain scale-[1.3] transform"
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* Right Arrow */}
        <div className="absolute right-[45px] sm:right-[105px] lg:right-[155px] z-10 flex items-center justify-end h-full">
          <img
            src={RightArrows}
            alt="Next"
            className="lg:w-[90px] md:w-[70px] w-[40px] cursor-pointer"
            onClick={next}
          />
        </div>
      </div>

      <div className="lg:mx-[95px] mx-[0px]">
        <div className="font-[Roboto] font-extrabold 2xl:text-[35px] xl:text-[30px] lg:text-[25px] md:text-[20px] text-[17px]">
          TU-1000EFI-2
        </div>
        <div className="grid lg:grid-cols-3 grid-cols-1 gap-4">
          <div className="col-span-2">
            <div className="font-[Roboto] font-normal 2xl:text-[30px] xl:text-[25px] lg:text-[20px] md:text-[17px] text-[15px]">
              3 seat gas utility vehicle featuring a powerful 1000cc combustion
              engine and built-in heater.
            </div>
          </div>
          <div className="col-span-1">
            <button
              onClick={() => {
                window.scrollTo(0, 200);
                navigate(RouterPaths.EFI);
              }}
              className="text-[#5B792E] font-[Roboto] lg:border-[4px] border-[2px] border-[#5B792E] font-bold lg:px-[45px] sm:px-[41px] px-[31px] lg:py-[17px] sm:py-[15px] py-[10px]  2xl:text-[30px] xl:text-[25px] lg:text-[20px] md:text-[17px] text-[15px]"
            >
              EXPLORE 1000EFI
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GasolineSlider;
